import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { createSharedSlice, type SharedSlice } from './slices/sharedSlice';

/**
 * Single bound store — mirrors the mobile useBoundStore pattern.
 * Add new slices here as the app grows.
 */
export const useBoundStore = create<SharedSlice>()(
  devtools(
    (...a) => ({
      ...createSharedSlice(...a),
    }),
    { name: 'MultiCareWebStore' },
  ),
);
